import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'

const ORANGE = '#FF5722'
const BG = '#0D0D0D'
const CARD = '#141414'
const BORDER = '#1f1f1f'

function BottomIcon({ id, active }) {
  const color = active ? ORANGE : '#444'

  if (id === 'home') {
    return active ? (
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path fill={color} d="M12.2 3.5c.3 2.8-.8 4.4-2 5.7-1.1 1.2-2.2 2.3-2.2 4.1a4.1 4.1 0 008.2 0c0-2.9-1.8-4.7-4-9.8z" />
      </svg>
    ) : (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12.2 3.5c.3 2.8-.8 4.4-2 5.7-1.1 1.2-2.2 2.3-2.2 4.1a4.1 4.1 0 008.2 0c0-2.9-1.8-4.7-4-9.8z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (id === 'discover') {
    return active ? (
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path fill={color} d="M7.2 4.5c.8 0 1.4.6 1.4 1.4v3.9l3.6 3.6 1.9-1.9-.9-.9a1.2 1.2 0 011.7-1.7l2.7 2.7a1.2 1.2 0 01-1.7 1.7l-.9-.9-1.9 1.9 3.6 3.6c.5.5.5 1.3 0 1.8l-.8.8-4.4-4.4-4.4 4.4-.8-.8a1.3 1.3 0 010-1.8l3.6-3.6-3.3-3.3V5.9c0-.8.6-1.4 1.4-1.4z" />
      </svg>
    ) : (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M8.2 4.5v5.8l3.8 3.8M5.9 4.5h4.6M6.8 7h2.8M13.2 9.6l4 4M16.8 8.4l1.8 1.8M15.6 10.8L9 17.4M8.6 19.8L19.8 8.6" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  if (id === 'matches') {
    return active ? (
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path fill={color} d="M6 5.5h12a3 3 0 013 3v6a3 3 0 01-3 3h-7.1L6.5 21v-3.5H6a3 3 0 01-3-3v-6a3 3 0 013-3z" />
      </svg>
    ) : (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 5.5h12a3 3 0 013 3v6a3 3 0 01-3 3h-7.1L6.5 21v-3.5H6a3 3 0 01-3-3v-6a3 3 0 013-3z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  return active ? (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="4" fill={color} />
      <path fill={color} d="M4 21a8 8 0 0116 0H4z" />
    </svg>
  ) : (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="2" />
    </svg>
  )
}

const foodEmojis = {
  'Biryani': '🍚', 'Pizza': '🍕', 'Dosa': '🥘',
  'Ramen': '🍜', 'Burger': '🍔', 'Sushi': '🍣',
  'Tacos': '🌮', 'Shawarma': '🧆', 'Butter Chicken': '🍛', 'Pasta': '🍝',
}

export default function Home({ session, onNavigate, currentScreen }) {
  const [cravings, setCravings] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState('home')

  useEffect(() => { fetchCravings() }, []) // eslint-disable-line

  async function fetchCravings() {
    setLoading(true)
    const now = new Date()
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString()
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).toISOString()

    const { data, error } = await supabase
      .from('cravings')
      .select('*')
      .eq('user_id', session.user.id)
      .gte('created_at', startOfDay)
      .lt('created_at', endOfDay)
      .order('created_at', { ascending: false })

    if (!error) setCravings(data || [])
    setLoading(false)
  }

  async function deleteCraving(cravingId) {
    const { error } = await supabase
      .from('cravings')
      .delete()
      .eq('id', cravingId)
      .eq('user_id', session.user.id)

    if (!error) {
      setCravings(prev => prev.filter(c => c.id !== cravingId))
    }
  }

  function handleNav(id) {
    setActiveTab(id)
    onNavigate(id)
  }

  const userInitial = session?.user?.email?.[0]?.toUpperCase()
  const userName = userInitial || 'S'
  const hour = new Date().getHours()
  const salutation = hour >= 5 && hour <= 11
    ? `Good morning, ${userName} ☀️`
    : hour >= 12 && hour <= 17
      ? `What's the plan, ${userName}?`
      : hour >= 18 && hour <= 21
        ? `Tonight's looking good, ${userName} 🌙`
        : `Still up, ${userName}? 🌙`

  function renderAmbientIcon() {
    if (hour >= 5 && hour <= 11) {
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none">
          <circle cx="27" cy="27" r="10" fill="#FFCA28" />
          <g stroke="#FFCA28" strokeWidth="2.5" strokeLinecap="round">
            <path d="M27 7v6" /><path d="M27 41v6" />
            <path d="M7 27h6" /><path d="M41 27h6" />
            <path d="M13 13l4.2 4.2" /><path d="M36.8 36.8L41 41" />
            <path d="M13 41l4.2-4.2" /><path d="M36.8 17.2L41 13" />
          </g>
        </svg>
      )
    }
    if (hour >= 12 && hour <= 17) {
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none">
          <circle cx="33" cy="21" r="7" fill="#FFCA28" />
          <path d="M13 33.5a6.5 6.5 0 016.3-6.5 8 8 0 0115 2.2 5.8 5.8 0 012.2-.4 5.9 5.9 0 010 11.8H18.8A5.8 5.8 0 0113 34.8v-1.3z" fill="#C8D2DC" />
        </svg>
      )
    }
    if (hour >= 18 && hour <= 21) {
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none">
          <rect x="8" y="32" width="38" height="2.5" rx="1.25" fill="#FF8F3A" />
          <path d="M17 32a10 10 0 0120 0" fill="#FF8F3A" />
          <path d="M17 32a10 10 0 0120 0" stroke="#FFA74D" strokeWidth="2" />
        </svg>
      )
    }
    return (
      <svg width="54" height="54" viewBox="0 0 54 54" fill="none">
        <path d="M33 13.5a14 14 0 107 25.8A12 12 0 1133 13.5z" fill="#D9E3FF" />
        <circle cx="12.5" cy="16.5" r="1.8" fill="#D9E3FF" />
        <circle cx="43" cy="18" r="1.5" fill="#D9E3FF" />
        <circle cx="38" cy="11" r="1.3" fill="#D9E3FF" />
      </svg>
    )
  }

  return (
    <div style={{
      minHeight: '100vh',
      maxWidth: '100%',
      margin: '0 auto',
      background: BG,
      fontFamily: "'DM Sans', sans-serif",
      paddingBottom: 72,
      position: 'relative'
    }}>

      <div style={{ padding: '52px 20px 0' }}>
        <div style={{
          marginBottom: 22,
          background: 'linear-gradient(135deg, #FF572218, #0D0D0D)',
          border: '1.5px solid #FF572230',
          borderRadius: 20,
          padding: 24,
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{ position: 'absolute', top: 14, right: 14, opacity: 0.95 }}>
            {renderAmbientIcon()}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <div style={{
              fontSize: 10,
              color: ORANGE,
              fontWeight: 700,
              letterSpacing: 1.5,
              textTransform: 'uppercase',
            }}>
              Tonight in Bangalore
            </div>
            <div
              onClick={() => handleNav('profile')}
              style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: `${ORANGE}22`,
                border: `2px solid ${ORANGE}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: ORANGE,
                fontWeight: 700,
                fontSize: 14,
                cursor: 'pointer',
                userSelect: 'none',
                flexShrink: 0,
                zIndex: 2,
                position: 'relative'
              }}
            >
              {userInitial}
            </div>
          </div>
          <div style={{
            fontSize: 28,
            fontWeight: 800,
            color: '#fff',
            lineHeight: 1.2,
            marginBottom: 10,
            maxWidth: '80%'
          }}>
            {salutation}
          </div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>
            Find people going for the same food, same vibe.
          </div>
          <button
            onClick={() => handleNav('post')}
            style={{
              background: ORANGE,
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '13px 24px',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: 0.2
            }}
          >
            Post a craving →
          </button>
        </div>
      </div>

      <div style={{ padding: '0 20px' }}>
        <div style={{
          fontSize: 10, fontWeight: 700, letterSpacing: 1.5,
          color: '#444', textTransform: 'uppercase', marginBottom: 14
        }}>
          Your cravings tonight
        </div>

        {loading ? (
          <div style={{ color: '#444', fontSize: 14, textAlign: 'center', paddingTop: 48 }}>
            Loading your cravings...
          </div>
        ) : cravings.length === 0 ? (
          <div style={{
            background: CARD, border: `1.5px solid ${BORDER}`,
            borderRadius: 20, padding: '40px 24px', textAlign: 'center'
          }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🍽️</div>
            <div style={{ color: '#fff', fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
              No cravings yet tonight
            </div>
            <div style={{ color: '#444', fontSize: 13, marginBottom: 16 }}>Post one and get matched faster</div>
            <button
              onClick={() => handleNav('post')}
              style={{
                background: ORANGE,
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                padding: '11px 18px',
                fontSize: 13,
                fontWeight: 700,
                cursor: 'pointer',
                fontFamily: "'DM Sans', sans-serif"
              }}
            >
              Post a craving →
            </button>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              overflowY: 'auto',
              maxHeight: 'calc(100vh - 340px)',
              paddingRight: 4
            }}
          >
            {cravings.map(craving => {
              const isExpired = craving.expires_at && new Date(craving.expires_at).getTime() < Date.now()
              return (
                <div
                  key={craving.id}
                  style={{
                    background: CARD,
                    border: `1.5px solid ${BORDER}`,
                    borderRadius: 14,
                    padding: '12px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    minHeight: 70,
                    opacity: isExpired ? 0.5 : 1,
                    flexShrink: 0
                  }}
                >
                  <div style={{ fontSize: 28, flexShrink: 0 }}>
                    {foodEmojis[craving.food_type] || '🍽️'}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>
                      {craving.food_type}
                      {isExpired && (
                        <span style={{
                          marginLeft: 8,
                          fontSize: 10,
                          color: '#888',
                          border: '1px solid #444',
                          borderRadius: 999,
                          padding: '1px 6px',
                          fontWeight: 400
                        }}>
                          Expired
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: 11, color: '#666', marginTop: 3 }}>
                      {craving.area} · {craving.time_slot}
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                    <button
                      disabled={isExpired}
                      onClick={() => onNavigate('discover', { filter: craving.food_type })}
                      style={{
                        background: 'transparent',
                        border: `1.5px solid #2a2a2a`,
                        color: ORANGE,
                        borderRadius: 10,
                        padding: '7px 10px',
                        fontSize: 11,
                        fontWeight: 700,
                        cursor: isExpired ? 'not-allowed' : 'pointer',
                        fontFamily: "'DM Sans', sans-serif",
                        opacity: isExpired ? 0.4 : 1,
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Who&apos;s going? 🔥
                    </button>
                    <button
                      onClick={() => deleteCraving(craving.id)}
                      style={{
                        width: 32,
                        height: 32,
                        background: '#101010',
                        border: `1.5px solid ${BORDER}`,
                        color: '#666',
                        borderRadius: 10,
                        fontSize: 15,
                        cursor: 'pointer',
                        fontFamily: "'DM Sans', sans-serif",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

{/* Bottom nav */}
      <div style={{
        position: 'fixed',
        bottom: 0, left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '100%',
        background: '#0a0a0a',
        borderTop: `1.5px solid ${BORDER}`,
        display: 'flex',
        padding: '10px 0 20px',
        zIndex: 100
      }}>
        {[
          { label: 'Home', id: 'home' },
          { label: 'Discover', id: 'discover' },
          { label: 'Matches', id: 'matches' },
          { label: 'Profile', id: 'profile' },
        ].map(nav => (
          <div
            key={nav.id}
            onClick={() => handleNav(nav.id)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 4,
              cursor: 'pointer',
              padding: '4px 0'
            }}
          >
            <BottomIcon id={nav.id} active={activeTab === nav.id} />
            <span style={{
              fontSize: 10,
              fontWeight: 500,
              color: activeTab === nav.id ? ORANGE : '#444',
              letterSpacing: 0.3
            }}>
              {nav.label}
            </span>
          </div>
        ))}
      </div>

    </div>
  )
}